import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import PageHeader1 from '../../components/common/PageHeader1';
import ActiveStatus from "../../components/Form/activeStatus";
import apiClient from "../../utils/api";
import { mockColors } from '../../components/Data/MockData';
import { toast } from 'react-toastify';

function ColorsEdit() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [formData, setFormData] = useState({
        name: '',
        is_active: "1"
    });

    useEffect(() => {
        fetchColor();
    }, [id]);

    const handleInputChange = (e) => {
        const { name, type, value, checked } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const fetchColor = async () => {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.get(`accounts/colors/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const colorData = {
                ...response.data.data,
                is_active: response.data.data.is_active.toString()
            };
            setFormData(colorData);
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error loading color');
        }
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        const data = new FormData();
        data.append('name', formData.name);
        data.append('is_active', formData.is_active);
        data.append('_method', 'PUT');
        
        try {
            const token = localStorage.getItem('auth_token');
            await apiClient.post(`accounts/colors/${id}`, data, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success('Color updated successfully');
            navigate(process.env.PUBLIC_URL + '/accounts/colors-list');
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error updating color');
        }
    };

    return (
        <div className="container-xxl">
            <form onSubmit={onSubmit}>
                <PageHeader1 pagetitle='Color Edit' button={true}/>
                <div className="row g-3">
                    <div className="col-xl-4 col-lg-4">
                        <div className="sticky-lg-top">
                            <div className="card mb-3">
                                <ActiveStatus
                                    onStatusChange={handleInputChange}
                                    checked={formData.is_active}
                                    name="is_active"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-8 col-lg-8">
                        <div className="card mb-3">
                            <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                                <h6 className="mb-0 fw-bold">Basic information</h6>
                            </div>
                            <div className="card-body">
                                <div className="row g-3 align-items-center">
                                    <div className="col-md-12">
                                        <label className="form-label">Color Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default ColorsEdit;